import React from 'react';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";

export function LawsuitColumnFormatter(cellContent) {
  return cellContent
    ? <img src={toAbsoluteUrl('/media/svg/Law_brandColor.svg')} alt="i" height={24}/>
    : '';
}
